import { getMonthName } from "common/helpers/utils";

function getDaySuffix(day: number): string {
  if (day > 3 && day < 21) return "th"; // covers 11th, 12th, 13th, etc.

  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

export function formatBillingDate(dateTimestamp: number): string {
  const date = new Date(dateTimestamp);
  const day = date.getDate();
  const daySuffix = getDaySuffix(day);
  const month = getMonthName(date.getMonth());
  const year = date.getFullYear();

  return `${month} ${day}${daySuffix}, ${year}`;
}

export function getDeploymentDomain() {
  return import.meta.env.VITE_GIT_BRANCH_NAME === "dev"
    ? "app.aimfox.dev"
    : `${import.meta.env.VITE_GIT_BRANCH_NAME.replace("feature/", "")}-aimfox.vercel.app`;
}
